var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, SurveyElementBase, SvgIcon, attachKey2click } from "survey-react-ui";
var ItemTemplateComponent = /** @class */ (function (_super) {
    __extends(ItemTemplateComponent, _super);
    function ItemTemplateComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemTemplateComponent.prototype.render = function () {
        var item = this.props.item;
        return (React.createElement(React.Fragment, null,
            React.createElement(SvgIcon, { iconName: item.iconName, size: item.iconSize, className: "svc-json-error__icon" }),
            React.createElement("div", { className: "svc-json-error__container" },
                React.createElement("div", { className: "svc-json-error__title" },
                    React.createElement("span", { key: 2 }, this.renderLocString(item.locTitle, undefined, "locString"))),
                this.renderFixButton())));
    };
    ItemTemplateComponent.prototype.renderFixButton = function () {
        if (!this.props.item.data.showFixButton)
            return null;
        var item = this.props.item;
        return (attachKey2click(React.createElement("button", { type: "button", onClick: function (event) { event.stopPropagation(); item.data.fixError(); }, title: item.data.fixButtonTitle, className: "svc-json-error__fix-button" },
            React.createElement(SvgIcon, { iconName: item.data.fixButtonIcon, size: "auto" }))));
    };
    return ItemTemplateComponent;
}(SurveyElementBase));
ReactElementFactory.Instance.registerElement("json-error-item", function (props) {
    return React.createElement(ItemTemplateComponent, props);
});
